import api from '@/utils/api';
import {
    GET_LIST_DOCTOR_APPOINTMENTS

} from './types';
import { NotificationManager } from 'react-notifications';

export const getListDoctorAppointments = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/doctor-appointments', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_DOCTOR_APPOINTMENTS, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}